import { gql } from '@apollo/client';

export const CREATE_INSPECTION_TEMPLATE = gql`
  mutation createInspectionTemplate($input: InspectionTemplate!) {
    inspectionTemplate(input: $input)
      @rest(
        type: "InspectionTypes"
        method: "POST"
        path: "/types/"
        endpoint: "inspections"
      ) {
      id
      name
      description
      inspectionType
      appManaged
      inspectionInterval
      reminderInterval
      handler
    }
  }
`;

export const CREATE_INSPECTION_WORKFLOW = gql`
  mutation createInspectionTemplate($adminData: adminData!) {
    inspectionWorkflow(adminData: $adminData)
      @rest(
        type: "InspectionWorkflow"
        method: "POST"
        bodyKey: adminData
        path: "/workflow/inspectionandworkflow?organizationId={args.adminData.organizationId}&facilityId={args.adminData.facilityId}&binderId={args.adminData.binderId}&issueTemplateId={args.adminData.issueTemplateId}&inspectionTemplateId={args.adminData.inspectionTemplateId}&inspectionStart={args.adminData.inspectionStart}&createCmTab={args.adminData.createCmTab}&tabName={args.adminData.tabName}"
        endpoint: "admin"
      ) {
      data
    }
  }
`;
export const CREATE_ISSUE_TEMPLATE = gql`
  mutation createIssueTemplate($input: IssueTemplate!) {
    issueTemplate(input: $input)
      @rest(
        type: "IssueTemplate"
        method: "POST"
        path: "/templates"
        endpoint: "issues"
      ) {
      data
    }
  }
`;

export const CREATE_GLOBAL_INSPECTION_TYPE = gql`
  mutation createGlobalInspectionType($input: InspectionTemplate!) {
    globalInspectionType(input: $input)
      @rest(
        type: "globalInspectionType"
        method: "POST"
        path: "/types/global"
        endpoint: "inspections"
      ) {
      id
      name
      description
      inspectionType
      appManaged
      inspectionInterval
      reminderInterval
      handler
    }
  }
`;

export const EDIT_GLOBAL_INSPECTION_TYPE = gql`
  mutation editGlobalInspectionType($input: InspectionTemplate!) {
    globalInspectionType(input: $input, inspectionTypeId: $inspectionTypeId)
      @rest(
        type: "globalInspectionType"
        method: "PUT"
        path: "/types/global/{args.inspectionTypeId}"
        endpoint: "inspections"
      ) {
      id
      name
      description
      market
      inspectionType
      inspectionInterval
      remindBeforeDueDate
      leniencyDocuments
      additionalDocuments
    }
  }
`;

export const DUPLICATE_INSPECTION_TYPE = gql`
  mutation duplicateInspectionTypeTemplate(
    $input: InspectionTemplate!
    $inspectionTypeId: String!
  ) {
    InspectionTemplate(input: $input, inspectionTypeId: $inspectionTypeId)
      @rest(
        type: "InspectionTemplate"
        method: "POST"
        path: "/types/global/duplicate/{args.inspectionTypeId}"
        endpoint: "inspections"
      ) {
      id
      name
      additionalDocuments
      leniencyDocuments
      appManaged
      description
      disabled
      inspectionInformation
      inspectionInterval
      remindBeforeDueDate
      isToggledOff
      inspectionType
      market
      reminderInterval
      supervisorRole
      supervisorUser
      tenantSpecific
    }
  }
`;

export const CREATE_INSPECTION_CATEGORY = gql`
  mutation createInspectionCategory($input: InspectionCategory!) {
    InspectionCategory(input: $input)
      @rest(
        type: "InspectionCategory"
        method: "POST"
        path: "/categories/global"
        endpoint: "inspections"
      ) {
      id
      name
    }
  }
`;
